import React, { Fragment, useState, useRef, useEffect } from 'react';
import { CueTip } from '../../../components/Common/CueTooltip';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import { SelectListPlaceholder, FieldLabel, OptionLabel, Description, RequiredErrMsg, WarningMsg, FieldReview, FieldPoint } from '../FieldLabel';
import useModal from "../../../hooks/useModal";
import GenericModal from "../../Modals/GenericModal";
import Cs from '../../../services/CommonService';
import { ImageFlexList } from '../../Common/Image';

const InputSelect = ({ labelLocale, renderField, formId, screen, field, formData, readOnly, errors, forceUpdate, formFn, isFormWizard, openDataSourceModal, openFieldLabelModal, currentLocale, position, fieldReview }) => {
  const clientId = field.client_id;

  let { current: scope } = useRef({
    opkv: field.options_key_value || {},
    options: [],
    objList: {}
  });

  const [selectedLabel, setSelectedLabel] = useState('');
  const [loading, setLoading] = useState(true);
  const [showOptions, setShowOptions] = useState(false);
  const [showError, setShowError] = useState(false);

  const { isOpen: isMenuOpen, toggleModal: toggleMenuModal } = useModal();

  const fieldEleRef = useRef();

  useEffect(() => {
    formFn[clientId + '_error_ds'] = field.error_data_source;
    formFn.ds[clientId] = formFn.ds[clientId] || {};
    if (renderField) setResult();
  }, [currentLocale, renderField])

  formFn["update_" + clientId] = (label) => {
    if (scope.options?.length === 0) setOptions();
    const selectedOption = scope.options.find(o => o.label == label);
    if (selectedOption) handleChange(selectedOption);
  }

  //set custom dropdown list if available or default to field options
  const setOptions = (list) => {
    if (list) {
      scope.options = list;
    } else {
      if (field.auto_gen_option) {
        scope.opkv.options = FormHelper.autoGenOptions(field.auto_gen_option, formData);
      }
      scope.options = (formFn[clientId + '_options'] || scope.opkv.options || field.options);
    }
  }

  const handleChange = (item) => {
    const isObj = (typeof item === 'object');
    const value = isObj ? item.value : item;
    formData[clientId] = (value == null ? null : FormHelper.isNumeric(value));
    
    //call on select function if exists
    const onSelectFn = formFn['on_select_' + clientId];
    onSelectFn && onSelectFn(item, errors[clientId]);
    formFn.ds[clientId] = item;
    
    //set label ui view
    const label = isObj ? OptionLabel({ "option": item, "currentLocale": currentLocale }) : item;
    setSelectedLabel(label);
   
    if (renderField) {
      setError(false);
      FormHelper.setFormTitle(field, formData, value, scope.opkv);
      FormHelper.checkCustomValidation(field, formData, formFn.ds, errors[clientId]);
      onOptionSelect(formData);
      forceUpdate();
      hideList();
    }
  }

  if (!renderField) return null;

  const setResult = () => {
    if (scope.opkv && scope.opkv.options && !field.auto_gen_option) {
      const selectedOption = scope.opkv.options.find(o => o.value == formData[clientId]);
      const label = selectedOption ? OptionLabel({ "option": selectedOption, "currentLocale": currentLocale }) : null;
      setSelectedLabel(label != null ? label : '');
      //scope.objList = scope.opkv.options.reduce((obj, item) => (obj[item.value] = OptionLabel({option:item, currentLocale:currentLocale}), obj), {});
    } else {
      setSelectedLabel(formData[clientId] ?? '');
    }
    setLoading(false);
  }

  let inputAttributes = {
    'id': clientId,
    'name': clientId,
    'placeholder': labelLocale(5),
    'disabled': readOnly,
    'required': field.required,
    'className': 'dd-button'
  }

  let parentAttributes = {
    'tooltip': field.tooltip
  }

  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);

  const clearSelection = (rerender = false) => {
    if (formData[clientId] != null) {
      formData[clientId] = null;
      FormHelper.setFormTitle(field, formData, null, scope.opkv);
    }
    setError(rerender);
  }

  /*TODO check usage*/
  const setInputValue = (optionList = [], inputValue, setValue) => {
    if (formData[clientId] == null) {
      const option = optionList[0];
      const label = scope.objList ? option?.label : option;
      if (label?.toLowerCase() == inputValue?.toLowerCase()) {
        setValue(scope.objList ? option?.label : option);
        handleChange(option);
      } else {
        setValue(null);
        forceUpdate();
      }
    }
    setError();
  }

  const updateByModalName = (targetKey, value) => {
    formFn["update_" + targetKey](value);
  }

  const onOptionSelect = () => {
    try {
      if (field.function_expression) {
        eval(field.function_expression);
      }
    } catch (e) {
      console.error(e.message)
    }
  }

  const setError = (rerender) => {
    if (field.required) {
      errors[clientId].invalid = (formData[clientId] == null || errors[clientId].err_msg) ? true : false;
      errors[clientId].touched = true;
      if (errors[clientId].invalid) {
        errors.invalid[clientId] = true;
      } else {
        delete errors.invalid[clientId];
      }
      if (rerender) {
        setShowError(!showError);
        formFn.refreshFormSubmit();
      }
    }
  }

  const exists = (item) => {
    return formData[clientId] == item;
  }

  const bindWindowClickEvent = () => {
    const onDropDownOpenFn = formFn['on_' + clientId + '_open'];
    if (onDropDownOpenFn) {
      onDropDownOpenFn(
        (field.options_key_value?.options || field.options),
        setOptions
      )
    } else {
      setOptions();
    }

    if (screen.xs == true) {
      toggleMenuModal();
    } else {
      //fstListRef.current.classList.remove("hidden");
      setShowOptions(true);
      formFn['is_' + clientId + '_open'] = true;
      window.addEventListener('click', eventFunction);
    }
  }

  const eventFunction = (event) => {
    try {
      if (fieldEleRef.current.contains(event.target)) {
        //console.log(field)
      } else {
        hideList();
        forceUpdate();
      }
    } catch (e) {

    }
  }

  const hideList = () => {
    if (screen.xs == true) {
      isMenuOpen && toggleMenuModal();
    } else {
      //fstListRef.current.classList.add("hidden");
      setShowOptions(false);
      formFn['is_' + clientId + '_open'] = false;
      window.removeEventListener("click", eventFunction);
    }
  }

  //FormHelper.setDisabled(field, inputAttributes);
  //FormHelper.checkFieldValidity(field, formData, errors);

  const Error = () => {
    if (field.required && (errors[clientId]?.touched || errors.isSubmitted) && errors[clientId]?.invalid) {
      return (
        <div className="errormsg">
          <span className="fas fa-exclamation-triangle m-r-5" />
          {errors[clientId].err_msg || <RequiredErrMsg {...{ field, labelLocale }} />}
        </div>
      )
    } else if (errors[clientId]?.warning_msg) {
      return (
        <div className="errormsg">
          <WarningMsg {...{ field, currentLocale }} lkey='gt_lt_msg' />
        </div>
      )
    }

    return null;
  }

  if (loading) return null;

  return (
    <Fragment>
      <div {...parentAttributes}>
        <div className="flex coldir m-b-20 tooltip">
          <CueTip
            positionCss={position > 1 ? 'top' : 'bottom'}
            tooltip={field.tooltip}
            currentLocale={currentLocale}
            locale={field.locale?.tooltip} />
          <FieldLabel field={field}
            isFormWizard={isFormWizard}
            labelAttributes={labelAttributes}
            currentLocale={currentLocale}
            openDataSourceModal={openDataSourceModal}
            openFieldLabelModal={openFieldLabelModal} />
          <div ref={fieldEleRef} id={clientId + '_container'} className={readOnly ? 'input-readonly' : ''} >
            {(scope.opkv && scope.opkv.options)
              ? <OptionsObjList selectedLabel={selectedLabel} list={scope.options}
                exists={exists} handleChange={handleChange} currentLocale={currentLocale}
                model={formData[clientId]} field={field} labelLocale={labelLocale}
                bindWindowClickEvent={bindWindowClickEvent} inputAttributes={inputAttributes}
                formId={formId} dataTypes={scope.opkv.data_types}
                setError={setError} clearSelection={clearSelection}
                setInputValue={setInputValue} showOptions={showOptions} />
              : <OptionsStringList list={scope.options} exists={exists} labelLocale={labelLocale}
                handleChange={handleChange} model={formData[clientId]} field={field}
                bindWindowClickEvent={bindWindowClickEvent} inputAttributes={inputAttributes}
                setError={setError} clearSelection={clearSelection}
                setInputValue={setInputValue} showOptions={showOptions}
                currentLocale={currentLocale} />
            }
          </div>
          <FieldPoint userRefId={formFn.userRefId} clientId={clientId}
            point={field.point} currentLocale={currentLocale}
            negPoint={field.incorrect_point} />
          <Description description={field.description} />
          <FieldReview review={fieldReview} />
          <Error />
        </div>
      </div>

      {isMenuOpen && (
        <GenericModal
          component={SingleSelectPopup}
          field={field}
          inputAttributes={inputAttributes}
          handleChange={handleChange}
          setError={setError}
          exists={exists}
          optionObjList={scope.options}
          optionStringList={scope.options}
          dataTypes={scope.opkv.data_types}
          title={field.label}
          isOpen={isMenuOpen}
          toggleModal={toggleMenuModal}
          currentLocale={currentLocale}
          clearSelection={clearSelection}
          setInputValue={setInputValue}
          description={field.description}
          labelLocale={labelLocale} />
      )}

    </Fragment>
  )
}

const OptionsStringList = ({ currentLocale, showOptions, labelLocale, list, model, exists, field, handleChange, clearSelection, bindWindowClickEvent, inputAttributes }) => {

  let [optionList, setOptionList] = useState();
  const inputEleRef = useRef();

  useEffect(() => {
    if (showOptions) {
      setOptionList(list.length > 100 ? list.slice(0, 100) : list);
    }
  }, [list])

  useEffect(() => {
    /*Popup mode selection change*/
    setSearch(model != null ? model : null);
  }, [model])

  const search = (term) => {
    clearSelection();
    if (term.length > 0) {
      setOptionList(FormHelper.searchList(list, term));
    } else {
      setOptionList([...list]);
    }
  }

  const setSearch = (term) => {
    inputEleRef.current.value = term;
  }

  const selectableItems = optionList && optionList.map((o, k) => {
    return (
      <li key={k} className={exists(o) ? 'dd-selected' : ''} onClick={e => handleChange(o)} title={o}>
        {o}
      </li>
    )
  })

  return (
    <Fragment>
      <div className="dropdown" onClick={e => bindWindowClickEvent(e)}>
        <input {...inputAttributes} defaultValue={model}
          ref={inputEleRef} onChange={e => search(e.target.value)}
          onFocus={() => setOptionList(list)} />
        <span className="dd-button-caret" />
        <i className="fas fa-times pos-abs lh-42 r-50" onClick={() => clearSelection(true)} />
      </div>
      {showOptions
        ? <ul className="dd-menu scroll-sm">
          {selectableItems}
          {optionList.length === 0
            ? <li><RequiredErrMsg {...{ field, labelLocale }} /></li>
            : <li><SelectListPlaceholder field={field} currentLocale={currentLocale} /></li>
          }
        </ul>
        : null
      }
    </Fragment>
  )
}

const OptionsObjList = ({ showOptions, dataTypes, labelLocale, list, selectedLabel, model, exists, field, handleChange, clearSelection, bindWindowClickEvent, inputAttributes, currentLocale }) => {

  let [optionList, setOptionList] = useState(list);
  const inputEleRef = useRef();
  let itemHeight = dataTypes && dataTypes.image_url ? { height: '100px' } : {};

  useEffect(() => {
    if (showOptions) {
      setOptionList(list.length > 100 ? list.slice(0, 100) : list);
    }
  }, [list])

  useEffect(() => {
    /*Popup mode selection change*/
    setSearch(model != null ? selectedLabel : null);
  }, [model])

  const search = (term) => {
    clearSelection()
    if (term.length > 0) {
      setOptionList(FormHelper.searchObjList(list, term));
    } else {
      setOptionList(list.length > 100 ? list.slice(0, 100) : list);
    }
  }

  const setSearch = (term) => {
    inputEleRef.current.value = term;
  }

  const selectableItems = optionList && optionList.map((o, k) => {
    return (
      <Fragment key={k}>
        <li style={itemHeight} className={exists(o.value) ? 'dd-selected' : ''}
          onClick={() => handleChange(o)} title={o.description}>
          <div>
            <OptionLabel option={o} currentLocale={currentLocale} />
            {itemHeight && o.image_url && <img src={Cs.getIconByType(o.image_url)} alt="img" className="w-100" style={{ height: "60px" }} />}
            {o.images ? <ImageFlexList styleName="radio-img" list={o.images} /> : null}
          </div>
        </li>
      </Fragment>
    )
  })

  return (
    <>
      <div className="dropdown" onClick={e => bindWindowClickEvent(e)} >
        <input {...inputAttributes} defaultValue={selectedLabel} ref={inputEleRef}
          onChange={e => search(e.target.value)} onFocus={() => setOptionList(list)} />
        <span className="dd-button-caret" />
        <i className="fas fa-times pos-abs lh-42 r-50" onClick={() => clearSelection(true)} />
      </div>
      {showOptions
        ? <ul className="dd-menu scroll-sm">
          {selectableItems}
          {optionList.length === 0
            ? <li className="errormsg"><RequiredErrMsg {...{ field, labelLocale }} /></li>
            : <li><SelectListPlaceholder field={field} currentLocale={currentLocale} /></li>}
        </ul>
        : null
      }
    </>
  )
}

const SingleSelectPopup = ({ field, inputAttributes, dataTypes, labelLocale, handleChange, clearSelection, exists, optionObjList, optionStringList, currentLocale }) => {

  let [optionList, setOptionList] = useState(optionObjList ? optionObjList : optionStringList);
  let itemHeight = dataTypes && dataTypes.image_url ? { height: '100px' } : {};
  const inputEleRef = useRef();

  const search = (term) => {
    clearSelection();
    if (term.length > 0) {
      setOptionList(OptionsObjList ? FormHelper.searchObjList(optionObjList, term) : FormHelper.searchList(optionStringList, term));
    } else {
      setOptionList(OptionsObjList ? optionObjList : optionStringList);
    }
  }

  const optionStringItems = optionList ? optionList.map((o, k) =>
    <li key={k} className={exists(o) ? 'dd-selected' : ''} onClick={() => handleChange(o)} title={o}>
      {o}
    </li>
  ) : null

  const optionObjectItems = optionList.map((o, k) =>
    <li key={k} style={itemHeight} className={exists(o.value) ? 'dd-selected' : ''}
      onClick={e => handleChange(o)} title={o.description}>
      <div className="font-16">
        <OptionLabel option={o} currentLocale={currentLocale} />
        {itemHeight && o.image_url && <img src={Cs.getIconByType(o.image_url)} alt="img" className="w-100 pull-right" style={{ height: "60px" }} />}
        {o.images ? <ImageFlexList styleName="radio-img" list={o.images} /> : null}
      </div>
    </li>
  )

  return (
    <div id="ct">
      <div className="dropdown">
        <input {...inputAttributes} ref={inputEleRef} onChange={e => search(e.target.value)} />
        <i className="fas fa-times pos-abs lh-42 r-50" onClick={() => clearSelection(true)} />
      </div>
      <ul className="dd-menu margin-unset">
        {OptionsObjList ? optionObjectItems : optionStringItems}
        {optionList.length === 0
          ? <li className="errormsg"><RequiredErrMsg {...{ field, labelLocale }} /></li>
          : <li><SelectListPlaceholder field={field} currentLocale={currentLocale} /></li>
        }
      </ul>
    </div>
  )

}
export default InputSelect;